import React, { useState, useEffect, useRef } from 'react';
import css from './ConnectScreen.module.scss';
import { useDispatch } from 'react-redux';
import { actions, useSelector } from '../store';
import { selectEndpoint, selectLine } from '../store/reducers/janus';

export default function ConnectScreen(props: {
  enabled: boolean
  extension?: string
  pin?: string
}) {
  const triedAutoConnectRef = useRef(false)
  const prefPinRef = useRef<undefined|null|string>(null)
  const [extension, setExtension] = useState(props.extension)
  const [pin, setPin] = useState(props.pin)
  const endpoint = useSelector(selectEndpoint)
  const line = useSelector(selectLine)
  const dispatch = useDispatch()

  useEffect(() => {
    if (props.pin !== prefPinRef.current) {
      triedAutoConnectRef.current = false
    }
    prefPinRef.current = props.pin
    setPin(props.pin)
  }, [props.pin])
  
  useEffect(() => setExtension(props.extension), [props.extension])

  //if offline and password is passed in the props
  useEffect(() => {
    if (!props.enabled) return
    
    if (!triedAutoConnectRef.current && props.extension && props.pin && (endpoint.status === 'offline') && endpoint.canConnect) {
      console.log('Auto connecting account using temp password')
      triedAutoConnectRef.current = true
      dispatch(actions.connectEndpoint(props.extension!, props.pin))
      setPin(undefined)
    }

    if (props.pin == null || props.pin.length === 0) {
      triedAutoConnectRef.current = false
    }
  }, [dispatch, endpoint.canConnect, endpoint.status, props.extension, props.pin, props.enabled])

  useEffect(() => {
    if (line.statusError === '403 Forbidden' && line.status === 'registering') {
      console.log('Password is invalid, not attempting auto connect')
      triedAutoConnectRef.current = true
      setPin('')
    }
  }, [line.statusError, line.status])

  useEffect(() => {
    if (!props.enabled && endpoint.canDisconnect) {
      console.log('Softphone is being disabled, disconnecting...')
      dispatch(actions.disconnectEndpoint())
    }

    if (!props.enabled) {
      // unset so we can retry next time it gets enabled
      triedAutoConnectRef.current = false
    }
  }, [dispatch, endpoint.canDisconnect, props.enabled])

  function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!pin || !extension) return
    dispatch(actions.connectEndpoint(extension, pin))
  }

  return <form autoComplete='on' className={css.connectScreen} onSubmit={onSubmit}>
    <label>
      Extension #
    <input value={extension ?? ''} onChange={e => setExtension(e.currentTarget.value)} />
    </label>
    <label>
      PIN
    <input type='password' value={pin ?? ''} onChange={e => setPin(e.currentTarget.value)} />
    </label>
    <button disabled={!endpoint.canConnect || endpoint.status === 'connecting' || !extension || !pin}>Connect</button>
    <div className={css.status}>Endpoint Status: {endpoint.status}</div>
    {endpoint.statusError && <div className={css.error}>{endpoint.statusError}</div>}
    {line.statusError && <div className={css.error}>{line.statusError}</div>}
  </form>
}
